import { AppError } from '~/shared/error/AppError';

export class InstrumentNotPresentError extends AppError {
  constructor() {
    super('error.INSTRUMENT_NOT_PRESENT');
  }
}
